import React, { useContext } from 'react'

import { Context } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object } from 'prop-types'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import ModelCard from 'Pods/Shared/ModelCard/ModelCard'

import { EMPTY_ARRAY, EMPTY_OBJECT, NOOP } from 'Utils/stableDefaults'
import useBreakpoint from 'Utils/useBreakpoint'

import { getCardCount } from './Constants'
import PromoPanel from './PromoPanel'
import Skeleton from './Skeleton'
import useUpsellModels from '../../Hooks/useUpsellModels'

function UpsellBlock({ cart = EMPTY_OBJECT }) {
  const context = useContext(Context)
  const {
    selectedFilters,
    cardSizeSetting,
    cardVisibilitySettings,
    browserAttributes,
    setSelectedFilters: handleFilterChange,
  } = context || {}
  const pageConfig = usePageConfig()
  const breakpoint = useBreakpoint()

  const hasFiltersLoaded = !!selectedFilters?.pricing
  const freeFromContext = !!selectedFilters?.pricing?.free
  const isFreeFilterActive = hasFiltersLoaded ? freeFromContext : !!browserAttributes?.searchingFree
  const keywords = selectedFilters?.keywords || ''

  const upsellBlockEnabled = !!pageConfig?.subscriptionListingUpsellBlock
  const isActiveSubscriber = !!pageConfig?.isActiveSubscriber
  const isEligible = upsellBlockEnabled && !isActiveSubscriber

  const { models, isLoading } = useUpsellModels({
    enabled: isFreeFilterActive && isEligible,
    keywords,
  })

  // Pre-hydration optimistic skeleton: avoids CLS for eligible users on the
  // high-intent free filter path. Ineligible users may see a brief flash;
  // acceptable trade-off vs. layout shift on hydration.
  if (isFreeFilterActive && !pageConfig) {
    return <Skeleton />
  }

  if (!isEligible || !isFreeFilterActive) return null
  if (isLoading) return <Skeleton />
  if (models.length === 0) return null

  const cardCount = getCardCount(breakpoint)
  const visibleModels = models.slice(0, cardCount)

  return (
    <div className="upsell-block col-12">
      <div className="card-3d-model upsell-block__promo-slot">
        <PromoPanel />
      </div>
      {visibleModels.map((model, index) => (
        <ModelCard
          key={model.id}
          {...model}
          cart={cart}
          modelIndex={index}
          listIndex={index}
          modelsPerRow={cardCount + 1}
          subscriptionFlowEnabled
          currentSelectedFileTypes={EMPTY_ARRAY}
          setSelectedFilters={handleFilterChange || NOOP}
          trackFilterChange={NOOP}
          cardVisibilitySettings={cardVisibilitySettings || EMPTY_OBJECT}
          cardSizeSetting={cardSizeSetting || 'medium'}
          setCartItemIds={NOOP}
          setWishListItems={NOOP}
        />
      ))}
    </div>
  )
}

UpsellBlock.propTypes = {
  cart: object,
}

export default UpsellBlock
